import { useState, useEffect } from 'react';
import type { ActivePopupModel } from '@pages/administration/announcements/announcements.models';
import { popupsApi } from '@pages/administration/announcements/popupsApi';
import { useAuthenticationContext } from '@utils/auth/AuthenticationContext';

export function useAnnouncementsLoader() {
    const { isInitialized, rootModel } = useAuthenticationContext();
    const [announcements, setAnnouncements] = useState<ActivePopupModel[]>([]);
    const divisionId = rootModel?.CurrentUserProfile.DivisionId;
    const labId = rootModel?.CurrentUserProfile.LabId;

    useEffect(() => {
        if (!isInitialized) return;
        let cancelled = false;
        popupsApi.getActivePopups()
            .then(result => { if (!cancelled) setAnnouncements(result); })
            .catch((err) => console.error('Failed to fetch announcements:', err));
        return () => { cancelled = true; };
    }, [isInitialized, divisionId, labId]);

    return { announcements };
}
